import {SimulatedAccountService} from "./SimulatedAccountService";
import {EquityAccountService} from "./EquityAccountService";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.services`;

    return angular.module(moduleName, [])
                  .service(EquityAccountService.id, EquityAccountService)
                  .service(SimulatedAccountService.id, SimulatedAccountService)
                  .name;
}
